export default "__VITE_ASSET__T$x6aK$F__"